export default {
  primary: {
    backgroundColor: 'primary',
    color: 'white',
    border: 'solid 2px',
    borderColor: 'primary',
    borderRadius: '40px',
    textTransform: 'uppercase',
    fontFamily: 'heading',
    fontWeight: 'bold',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: ['0.8rem', '', '0.9rem'],
    padding: '1rem 1.7rem',
    transition: 'all ease-in-out 0.5s',
    border: 'solid 1px white',
    width: 'fit-content',
    ':hover': {
      backgroundColor: 'transparent',
      borderColor: 'primary',
      color: 'text'
    }
  },
  secondary: {
    color: 'light',
    border: 'solid 2px',
    borderColor: 'secondary',
    borderRadius: '0px',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    fontFamily: 'body',
    fontWeight: 'bold',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: ['0.9rem', '', '1rem'],
    padding: '1rem',
    transition: 'all ease-in-out 0.5s',
    ':hover': {
      backgroundColor: 'secondary',
      borderColor: 'white'
    }
  }
}
